import React from 'react'

import { withLocalize } from "react-localize-redux";
import { registerLocale } from "react-datepicker";
import { connect } from 'react-redux';

import fr from 'date-fns/locale/fr'
import en from 'date-fns/locale/en-US'
import sp from 'date-fns/locale/sq'
import de from 'date-fns/locale/de'
import it from 'date-fns/locale/it'

import Header from './partials/Header'
import globalTranslations from "../assets/translations/common.json";
import operational from "../assets/translations/operational.json";
import engineering from  "../assets/translations/engineering.json";
import technicals from  "../assets/translations/technicals.json";
import context from '../assets/translations/context.json';
import interfaceTrad from '../assets/translations/interface.json';
import quaterlyTrad from '../assets/translations/quaterly.json'
import implication  from '../assets/translations/implication.json';
import project from '../assets/translations/project.json'

const onMissingTranslation = ({ defaultTranslation }) => {
  return ''
};


registerLocale('fr', fr)
registerLocale('en', en)
registerLocale('sp', sp)
registerLocale('de', de)
registerLocale('it', it)


class Page extends React.Component{

  constructor(props) {
    super(props);

    this.props.initialize({
      languages: [
        { name: "English", code: "en" },
        { name: "French", code: "fr" },
        { name: "Spanish", code: "es" },
        { name: "German", code: "de" },
        { name: "Italian", code: "it" },
      ],
      translation: Object.assign({}, project, globalTranslations, operational, engineering , technicals , context ,  interfaceTrad , implication, quaterlyTrad),
      options: {
        renderToStaticMarkup : false,
        onMissingTranslation
     }
    });
  }

  render(){

    const className = this.props.wide ? "wide" : ""

    return (
      <div className="App">
        {this.props.isLoading ? <div id="loader">
          <i className="fa fa-circle-notch fa-spin fa-3x" style={{ color: '#eb4f1e' }}></i>
        </div> : null
        }
        <Header/>
        <div className={"container "+className} style={{ whiteSpace: 'pre-line' }} >
          { this.props.children }
        </div>
      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    isLoading: state.document.isLoading,
  };
}

// export default withLocalize(Page)
export default connect(mapStateToProps)(withLocalize(Page));
